import shopifyGenericDefaults from '../shopify-generic/config.js';

const addToCart = (variantIds) => async (e) => {
  e.preventDefault();
  e.stopPropagation();

  const buttonSpinner = e.target.querySelector('.cm_loading');
  const buttonText = e.target.querySelector('.cm_add-to-cart-text');

  if (buttonText && buttonSpinner) {
    buttonText.style.display = 'none';
    buttonSpinner.classList.toggle('cm_loading');

    const response = await setAjaxAddToCart(variantIds);

    if (response.ok) {
      const cartItems = await getAjaxAddToCart();

      if (cartItems) {
        window.wetheme.toggleRightDrawer('cart', true, { cart: cartItems });
      }
    } else {
      console.error(response);
    }

    buttonText.style.display = 'block';
    buttonSpinner.classList.toggle('cm_loading');
  }
};

window.Convermax.addToCart = addToCart;

window.Convermax.addAllProductsToCart = async (e) => {
  const variantIds = [
    ...document.querySelectorAll('.cm_SearchResult .add-to-cart--secondary[data-cm-variant]'),
  ].map((el) => el.getAttribute('data-cm-variant'));
  addToCart(variantIds)(e);
};

async function setAjaxAddToCart(ids) {
  const formData = { items: groupIdsWithQuantity(ids) };

  return fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData),
  });
}

async function getAjaxAddToCart() {
  return fetch(`/cart?view=compare`).then((res) => {
    return res.json();
  });
}

function groupIdsWithQuantity(ids) {
  const map = ids.reduce((acc, id) => {
    acc[id] = (acc[id] || 0) + 1;
    return acc;
  }, {});

  return Object.entries(map).map(([id, quantity]) => ({
    id: Number(id),
    quantity,
  }));
}

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  searchPage: '/pages/find-your-wipers',
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter((w) => !['VerifyFitment'].includes(w.name)),
    {
      name: 'HeaderVehicleWidget_wipers',
      type: 'VehicleWidget',
      location: { insertAfter: 'body#find-your-wipers .accordion-container' },
      template: 'fitmentSearch/homeVehicleWidget',
      isAlwaysColumnLayout: true,
      isAlwaysActive: true,
      fields:
        !!window.Convermax.config?.extraFieldsAsFilters && shopifyGenericDefaults.fitmentSearch.baseFields,
    },
    {
      name: 'VerifyFitment',
      location: '#cm-verify-fitment',
      template: 'fitmentSearch/verifyFitment',
    },
  ],
};
